import React from "react";
import { Container, Row, Col } from "reactstrap";
import { DEVELOP_BY, PLATFORM_NAME } from "../../CommonData/Data/constant";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col sm={6}>
              {new Date().getFullYear()} © {PLATFORM_NAME}.
            </Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                Developed with <i className="mdi mdi-heart text-danger"></i> by{" "}
                {DEVELOP_BY}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
